import CryptoJS from 'crypto-js'
import { getDescriptionIntegrityKey } from './authKeysStore'

export const encrypt = (text) => {
  return CryptoJS.AES.encrypt(
    text,
    'Güvenlik ve emniyet için hesabım mobil sürüm 25154222146'
  ).toString()
}
export const decrypt = (encryptedHex) => {
  return CryptoJS.AES.decrypt(
    encryptedHex,
    'Güvenlik ve emniyet için hesabım mobil sürüm 25154222146'
  ).toString(CryptoJS.enc.Utf8)
}

const getSafeText = (text) => {
  if (text === null || text === undefined) {
    return ''
  }
  return String(text)
}

export const getDescriptionSignature = (text) => {
  const normalizedText = getSafeText(text)
  const hash = CryptoJS.HmacSHA256(
    normalizedText,
    getDescriptionIntegrityKey()
  )
  return CryptoJS.enc.Base64.stringify(hash)
}

export const isDescriptionSignatureValid = (text, signature) => {
  if (!signature || typeof signature !== 'string') {
    return false
  }
  const normalizedSignature = signature.trim()
  if (!normalizedSignature) {
    return false
  }
  try {
    const calculatedSignature = getDescriptionSignature(text)
    return calculatedSignature === normalizedSignature
  } catch (error) {
    console.error('Failed to validate description integrity', error)
    return false
  }
}
